import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Navbar from './Navbar';
import AccountDeletionSection from './AccountDeletionSection';
import './AccountDeletion.css';

function AccountDeletion() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="account-deletion-page">
      <Navbar />
      <button className="back-button" onClick={() => navigate('/')} aria-label="Go back to home">
        <FaArrowLeft /> Back
      </button>

      <div className="account-deletion-page-content">
        <AccountDeletionSection />
      </div>
    </div>
  );
}

export default AccountDeletion;
